import axios from 'axios';
import { ApiBaseUrl } from '@/constants';

/**
 * Registra consumo de API externa feita no browser (fire-and-forget).
 * @param {string} operador - ex.: VIACEP, MAPBOX
 * @param {string} servico - ex.: CEP_LOOKUP, GEOCODE_REVERSE
 * @param {number} [quantidade=1]
 * @param {string} [token] - JWT; usa sessionStorage 'api' se omitido
 */
export default function registrarChamadaApiExterna(operador, servico, quantidade = 1, token) {
    const authToken = token || sessionStorage.getItem('api');
    if (!authToken || !operador || !servico || !ApiBaseUrl) {
        return;
    }
    axios
        .post(
            ApiBaseUrl + '/api/v1.0/registrarchamadasapiexternas',
            {
                chamadas: [{
                    operador,
                    servico_api_externa: servico,
                    quantidade
                }]
            },
            { headers: { 'x-access-token': authToken } }
        )
        .catch(() => {});
}
